export default __webpack_public_path__ + "images/9942d3b5c1df9b6f35e17483724162c7.svg";